import React, { useEffect, useRef, useState } from 'react'
import Header from '../layout/Header'
import { formatDatee } from '../../helpers/converter'
import { Link, useParams } from 'react-router-dom'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getApplications } from '../../actions/application/getApplications'
import { pagingApplicationNurse } from '../../actions/nurse/pagingApplicationNurse'
import { applicationNotePatient } from '../../actions/application/applicationNotePatient'
import { addNoteToApplication } from '../../actions/nurse/addNoteToApplication'
import { formatZuluTime } from '../../helpers/formatter'
import { applicationPatientChatRight } from '../../actions/application/applicationPatientChatRight'
import Swal from 'sweetalert2'

function ApplicationNote(props) {
    const dispatch = useDispatch();
    const { Id } = useParams();
    const [message, setMessage] = useState('');
    const user = JSON.parse(localStorage.getItem('user'));

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        dispatch(applicationNotePatient(Id));
        dispatch(applicationPatientChatRight(Id))
    }, [dispatch, Id]);

    useEffect(() => {
        if (props.addNoteToApplication.done) {
            setMessage('');
            dispatch(applicationNotePatient(Id));
        }
    }, [props.addNoteToApplication, dispatch, Id]);

    const sortedNotes = props.applicationNotePatient?.applicationNotePatient?.result?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

    useEffect(() => {
        scrollToBottom();
    }, [sortedNotes]);

    useEffect(() => {
        dispatch(applicationNotePatient(Id))
    }, [dispatch])

    useEffect(() => {

        if (props.addNoteToApplication.done) {
            dispatch(applicationNotePatient(Id))
            return;
        }

        if (props.addNoteToApplication.error != false) {
            Swal.fire({
                icon: "warning",
                title: "Uyarı...",
                text: "Mesaj gönderme sınırına ulaştınız!",
                confirmButtonText: "Anladım"
            });
        }


    }, [props.addNoteToApplication])



    return (
        <div>
            <Header />
            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex flex-row justify-between whitespace-nowrap min-w-0" aria-label="Breadcrumb">

                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                        Başvuru Notları
                    </li>
                    <li className="text-sm text-red-500 truncate dark:text-gray-200 mr-5" aria-current="page">
                        {props.applicationPatientChatRight?.applicationPatientChatRight?.result?.remainingChatCount === 0 ?
                            <>
                                Başvuru mesaj hakkınız bitmiştir.
                            </>
                            :
                            <>
                                {props?.applicationPatientChatRight?.applicationPatientChatRight?.result?.finalDate ?
                                    <>Başvuru sonucunuz ile ilgili {formatZuluTime(props?.applicationPatientChatRight?.applicationPatientChatRight?.result?.finalDate)} tarihine kadar {props.applicationPatientChatRight?.applicationPatientChatRight?.result.remainingChatCount} soru sorma hakkınız mevcuttur.
                                    </>
                                    : null}
                            </>
                        }
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            <div className='relative mt-5 ps-5 pe-5 md:ml-64 mb-20 '> {/* mb-20, input alanı için altta yer açar */}
                <ul className="space-y-5 text-start overflow-y-auto max-h-[calc(100vh-200px)]"> {/* Ekran yüksekliğine bağlı dinamik max-height */}
                    {sortedNotes?.map((note, index) => {
                        const isUserMessage = note?.userId === user?.id;
                        return (
                            <li key={note.id} className={`me-10 flex  ${isUserMessage ? 'justify-end' : 'justify-start'}`}>
                                <div
                                    ref={messagesEndRef}
                                    className={`max-w-lg ${isUserMessage ? 'flex-row-reverse text-right' : 'flex-row'} gap-x-2 sm:gap-x-4 overflow-hidden`}>
                                    <div
                                        className={`border border-gray-200 rounded-2xl p-4 space-y-3
                                        ${isUserMessage ? 'bg-blue-600 text-white' :
                                                note.commentSource === 0 ? `bg-[#CEF3DE] dark:bg-slate-900 dark:border-gray-700` :
                                                    note.commentSource === 1 ? `bg-[#9DE7BE] dark:bg-slate-900 dark:border-gray-700` :
                                                        note.commentSource === 2 ? `bg-[#6BDB9D] dark:bg-slate-900 dark:border-gray-700` :
                                                            note.commentSource === 3 ? `bg-[#3ACF7D] dark:bg-slate-900 dark:border-gray-700` :
                                                                null}`}>
                                        <p>
                                            {note.commentSource === 0 ? '' :
                                                note.commentSource === 1 ? 'Doktor' :
                                                    note.commentSource === 2 ? 'Başvuran' :
                                                        note.commentSource === 3 ? 'Hemşire' : null}
                                            &nbsp;
                                            {note.commentOwnerFullName}</p>
                                        <p
                                            className={`text-sm ${isUserMessage ? 'text-white' : 'text-gray-800 dark:text-white'} break-words overflow-wrap`}>
                                            {note.text}
                                        </p>
                                        <div
                                            className={`text-xs ${isUserMessage ? 'text-white text-right' : 'text-gray-800'} text-left`}>
                                            {formatDatee(note.createdAt)}
                                            <br />
                                            {formatZuluTime(note.createdAt)}

                                        </div>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className='fixed bottom-0 left-0 right-0 md:ml-64 ps-5 pe-5 pb-5 bg-white dark:bg-slate-900'> {/* Arka plan rengi eklendi */}
                <div className="flex flex-row justify-between">
                    <textarea
                        rows={3}
                        onKeyDown={(e) => { if (e.key === 'Enter') { dispatch(addNoteToApplication(Id, message)); e.target.value = ''; } }}
                        onChange={(e) => setMessage(e.target.value)}
                        type="text"
                        value={message}
                        className="me-2 py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                        placeholder="İletmek istediğiniz notu girin..."
                    />
                    <button
                        onClick={() => {
                            dispatch(addNoteToApplication(Id, message));
                            setMessage('');
                        }}
                        type="button"
                        className="ms-2 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                    >
                        <i className="fa-sharp fa-solid fa-paper-plane-top"></i>
                    </button>
                </div>
            </div>


        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps)(ApplicationNote);